import { useRef } from 'react';

/**
 * Returns a ref that's always kept in sync with the latest `value`, refreshed on every render.
 *
 * Use this to read a fresh value from inside a callback that might end up being invoked long after
 * the render that created it closed over `value` -- most commonly a drag-end handler that commits
 * the final dragged position after several intervening re-renders moved it. Without this, the
 * callback silently keeps whatever `value` was at the moment it was created, which can be far
 * earlier than when it's actually called.
 */
export function useLatest<T>(value: T) {
    const ref = useRef(value);
    ref.current = value;
    return ref;
}
